export type AnalyticsEvent =
  | "landing_view"
  | "puzzle_start"
  | "puzzle_complete"
  | "daily_complete"
  | "share_clicked"
  | "return_visit"
  | "collection_view"
  | "web_vitals";

/**
 * `beacon` is for the reports sent as the page goes away. A request started from a
 * `visibilitychange` handler is racing the browser's decision to freeze the tab, and
 * on a phone switching apps `fetch` loses that race often enough to bias the numbers
 * towards the sessions that happened to survive. sendBeacon is queued by the browser
 * itself and outlives the document.
 */
export function track(
  event: AnalyticsEvent,
  properties: Record<string, string | number | boolean> = {},
  options: { beacon?: boolean } = {},
): void {
  const payload = JSON.stringify({ event, properties });

  if (options.beacon && typeof navigator.sendBeacon === "function") {
    // The endpoint checks the content type, which a string body would not carry.
    const queued = navigator.sendBeacon("/api/events", new Blob([payload], { type: "application/json" }));
    if (queued) return;
  }

  void fetch("/api/events", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: payload,
    keepalive: true,
  }).catch(() => {
    // Analytics must never interrupt a puzzle session.
  });
}
